import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../axiosConfig";

const ConfirmOffice = () => {
  const { cv_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const confirmInterview = async () => {
      try {
        setLoading(true);
        const response = await axios.put(
          `https://api.comnieuthienly.vn/api/confirm-office-interview/${cv_id}`
        );
        
        if (response.data && (response.data.code === 200 || response.data.success === true)) {
          setLoading(false);
        } else {
          setError("Có lỗi xảy ra khi xác nhận phỏng vấn.");
          setLoading(false);
        }
      } catch (err) {
        console.error("Error confirming interview:", err);
        setError(err.response?.data?.msg || "Có lỗi xảy ra khi xác nhận phỏng vấn.");
        setLoading(false);
      }
    };

    if (cv_id) {
      confirmInterview();
    }
  }, [cv_id]);

  return (
    <div className="container mx-auto">
      <div
        className="flex flex-col items-center justify-between"
        style={{ height: "100vh" }}
      >
        <div>
          <div className="banner-img card-banner"></div>
          <div className="wrap-body">
            <div className="line"></div>
            <div className="text">
              <div className="text-content">
                {loading ? (
                  <p>Đang xử lý...</p>
                ) : error ? (
                  <p style={{ color: "red" }}>{error}</p>
                ) : (
                  <>
                    <p>
                      Bộ phận Tuyển dụng đã nhận được thông tin xác nhận của bạn. 
                      Cảm ơn bạn đã xác nhận tham gia phỏng vấn theo thông tin như trên 
                      thư mời chúng tôi đã gửi.
                    </p>
                    <div style={{ height: 10 }}></div>
                    <p>
                      Mọi yêu cầu hỗ trợ, Bạn vui lòng liên hệ Bộ phận Tuyển dụng – 
                      0934.785.500. Chúng tôi xin gửi lời chúc tốt đẹp nhất đến Bạn 
                      trong buổi phỏng vấn sắp tới & Chúc Bạn có một buổi phỏng vấn 
                      thành công! Hẹn gặp Bạn tại buổi phỏng vấn.
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <a
          className="style-link flex flex-row items-center justify-center"
          href="https://comnieuthienly.vn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            style={{
              aspectRatio: "auto 74 / 24",
              width: "200px",
            }}
            src="https://i.imgur.com/nB8LOLM.png"
            alt="img-logo-thien-ly"
          />
        </a>
      </div>
    </div>
  );
};

export default ConfirmOffice;

